<script setup lang="ts">
import { computed, ref } from 'vue'

import PrimeMenu from 'primevue/menu'
import type { MenuItem } from 'primevue/menuitem'

import AppButton from 'primevue/button'
import { useI18nStore } from '@/stores/useI18nStore'
import { useThemeStore } from '@/stores/useThemeStore'

const i18nStore = useI18nStore()
const menu = ref<InstanceType<typeof PrimeMenu> | null>(null)
const target = ref<HTMLElement | null>(null)

const languageCountryMap = {
  en: 'us',
  es: 'es',
}

const items = computed<MenuItem[]>(() => [
  {
    label: 'English',
    icon: languageCountryMap.en,
    command: () => i18nStore.changeLanguage('en'),
  },
  {
    label: 'Español',
    icon: languageCountryMap.es,
    command: () => i18nStore.changeLanguage('es'),
  },
])

const tooltipText = computed(() => 'Select Language')

const currentFlag = computed(() => languageCountryMap[i18nStore.language])

function openMenu(event: Event) {
  menu.value?.toggle(event)
}

const themeStore = useThemeStore()

const buttonSeverity = computed(() => (themeStore.isDark ? 'primary' : 'secondary'))
</script>

<template>
  <div class="flex items-center">
    <AppButton
      ref="target"
      rounded
      :severity="buttonSeverity"
      variant="outlined"
      icon="pi pi-language"
      v-tooltip.bottom="tooltipText"
      @click="openMenu"
    />

    <PrimeMenu ref="menu" :model="items" popup>
      <template #item="{ item }">
        <div
          class="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors"
        >
          <span v-if="item.icon === currentFlag" class="pi pi-check w-4"></span>
          <span v-else class="w-4"></span>
          <span :class="['country-flag', item.icon, 'text-base']"></span>
          <span class="font-medium">{{ item.label }}</span>
        </div>
      </template>
    </PrimeMenu>
  </div>
</template>
